// extracted by mini-css-extract-plugin
export default {"customMarks":"CustomMarks_customMarks__xfgsw","mark":"CustomMarks_mark__+MOwM","activeMark":"CustomMarks_activeMark__cRvSq"};